var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
import { DevPlanMethod } from '../../store/signup/models';
var DeveloperPlansService = services.DeveloperPlansService, BundleService = services.BundleService, ResellerService = services.ResellerService;
export var getManageDevPlanByResellerId = function (reseller_id, managed_id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var developerPlans, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_DEVELOPER_PLAN_REQUEST' });
                    return [4 /*yield*/, DeveloperPlansService.getManageDevPlanByResellerId(reseller_id, managed_id)];
                case 1:
                    developerPlans = (_a.sent()).objects;
                    dispatch({
                        type: 'LOAD_DEVELOPER_PLAN_SUCCESS',
                        developerPlans: developerPlans,
                        developerPlansOrg: managed_id,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    dispatch({ type: 'LOAD_DEVELOPER_PLAN_FAILURE', err: err_1 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var changeInterval = function (interval) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'CHANGE_DEVELOPER_PLAN_INTERVAL_REQUEST',
                interval: DevPlanMethod.Annually,
            });
            dispatch({
                type: 'CHANGE_DEVELOPER_PLAN_INTERVAL_SUCCESS',
                interval: interval,
            });
        }
        catch (err) {
            dispatch({
                type: 'CHANGE_DEVELOPER_PLAN_INTERVAL_FAILURE',
                interval: DevPlanMethod.Annually,
            });
        }
        return [2 /*return*/, null];
    });
}); }; };
export var addBundlesToDevPlanManagedOrg = function (resellerOrgId, managedOrgId, bundles) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_REQUEST' });
                return [4 /*yield*/, ResellerService.addBundlesToDevPlanManagedOrg(resellerOrgId, managedOrgId, bundles)];
            case 1:
                _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                err_2 = _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
export var removeBundlesFromDevPlanManagedOrg = function (resellerOrgId, managedOrgId, bundles) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_REQUEST' });
                return [4 /*yield*/, ResellerService.removeBundlesFromDevPlanManagedOrg(resellerOrgId, managedOrgId, bundles)];
            case 1:
                _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                err_3 = _a.sent();
                dispatch({ type: 'PURCHASE_DEV_PLAN_BUNDLES_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
export var purchaseDeveloperPlansOrg = function (resellerOrgId, managedOrgId, devPlanId, bundle) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var purchasedDeveloperPlan, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PURCHASE_DEVELOPER_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.purchaseDeveloperPlansManagedOrg(resellerOrgId, managedOrgId, devPlanId, bundle)];
            case 1:
                purchasedDeveloperPlan = (_a.sent()).object;
                if (purchasedDeveloperPlan) {
                    dispatch({
                        type: 'PURCHASE_DEVELOPER_PLAN_SUCCESS',
                        purchasedDeveloperPlan: purchasedDeveloperPlan,
                    });
                    dispatch(getManagedOrgDevPlanStatus(resellerOrgId, managedOrgId));
                    dispatch(getManageDevPlanByResellerId(resellerOrgId, managedOrgId));
                }
                return [2 /*return*/, true];
            case 2:
                err_4 = _a.sent();
                dispatch({ type: 'PURCHASE_DEVELOPER_PLAN_FAILURE', err: err_4 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var listBundlesPurchasableByManagedOrg = function (resellerOrgId, managedOrgId, DevPlanID) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var bundles, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_BUNDLES_REQUEST' });
                    return [4 /*yield*/, BundleService.listBundlesAvailableByManagedOrg(resellerOrgId, managedOrgId, DevPlanID)];
                case 1:
                    bundles = (_a.sent()).objects;
                    dispatch({
                        type: 'LOAD_BUNDLES_SUCCESS',
                        bundles: bundles,
                        bundlesOrg: managedOrgId,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_5 = _a.sent();
                    dispatch({ type: 'LOAD_BUNDLES_FAILURE', err: err_5 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var getActiveBundles = function (resellerOrgId, managedOrgId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var ActiveBundles, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_ACTIVE_BUNDLES_REQUEST' });
                    return [4 /*yield*/, BundleService.listActiveManagedOrgBundles(resellerOrgId, managedOrgId)];
                case 1:
                    ActiveBundles = (_a.sent()).objects;
                    dispatch({
                        type: 'LOAD_ACTIVE_BUNDLES_SUCCESS',
                        ActiveBundles: ActiveBundles,
                        activeBundlesOrg: managedOrgId,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _a.sent();
                    dispatch({ type: 'LOAD_ACTIVE_BUNDLES_FAILURE', err: err_6 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var updateActiveBundles = function (selectedBundles) {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_ACTIVE_BUNDLES_SUCCESS',
            selectedBundles: selectedBundles,
        });
    };
};
export var updateUpdatedAddons = function (selectedBundles) {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_UPDATED_ADDONS_SUCCESS',
            selectedBundles: selectedBundles,
        });
    };
};
export var getManagedOrgDevPlanStatus = function (resellerOrgId, managedOrgId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var devPlanStatus, err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'DEV_PLAN_STATUS_REQUEST' });
                    return [4 /*yield*/, DeveloperPlansService.getManagedOrgDevPlanStatus(resellerOrgId, managedOrgId)];
                case 1:
                    devPlanStatus = (_a.sent()).object;
                    dispatch({
                        type: 'DEV_PLAN_STATUS_SUCCESS',
                        devPlanStatus: devPlanStatus,
                        managedOrgId: managedOrgId,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_7 = _a.sent();
                    dispatch({ type: 'DEV_PLAN_STATUS_FAILURE', err: err_7 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var cancelDevPlan = function (resellerOrgId, managedOrgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'CANCEL_DEV_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.cancelManagedOrgDevPlan(resellerOrgId, managedOrgId)];
            case 1:
                _a.sent();
                dispatch({ type: 'CANCEL_DEV_PLAN_SUCCESS' });
                return [2 /*return*/, dispatch(getManagedOrgDevPlanStatus(resellerOrgId, managedOrgId))];
            case 2:
                err_8 = _a.sent();
                dispatch({ type: 'CANCEL_DEV_PLAN_FAILURE', err: err_8 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var reactivateDevPlanStatus = function (resellerOrgId, managedOrgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'REACTIVATE_DEV_PLAN_REQUEST' });
                return [4 /*yield*/, DeveloperPlansService.reactivateManagedOrgDevPlan(resellerOrgId, managedOrgId)];
            case 1:
                _a.sent();
                dispatch({ type: 'REACTIVATE_DEV_PLAN_SUCCESS' });
                return [2 /*return*/, dispatch(getManagedOrgDevPlanStatus(resellerOrgId, managedOrgId))];
            case 2:
                err_9 = _a.sent();
                dispatch({ type: 'REACTIVATE_DEV_PLAN_FAILURE', err: err_9 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getManagedOrgConsumedDeveloperPlan = function (resellerOrgId, managedOrgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var devPlanConsume, err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'GET_MANAGED_ORG_DEV_PLAN_CONSUMED_REQUEST' });
                return [4 /*yield*/, BundleService.getManagedOrgConsumedDeveloperPlan(resellerOrgId, managedOrgId)];
            case 1:
                devPlanConsume = (_a.sent()).object;
                dispatch({
                    type: 'GET_MANAGED_ORG_DEV_PLAN_CONSUMED_SUCCESS',
                    devPlanConsume: devPlanConsume,
                    devPlanConsumeOrg: managedOrgId,
                });
                return [3 /*break*/, 3];
            case 2:
                err_10 = _a.sent();
                dispatch({ type: 'GET_MANAGED_ORG_DEV_PLAN_CONSUMED_FAILURE', err: err_10 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getDevPlanInvoiceDetails = function (resellerOrgId, managedOrgId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var devPlanInvoiceDetails, err_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, DeveloperPlansService.getManagedOrgDevPlanInvloiceDetails(resellerOrgId, managedOrgId)];
                case 1:
                    devPlanInvoiceDetails = (_a.sent()).object;
                    dispatch({
                        type: 'DEV_PLAN_INVOICE_DETAILS_SUCCESS',
                        devPlanInvoiceDetails: devPlanInvoiceDetails,
                        managedOrgId: managedOrgId,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_11 = _a.sent();
                    dispatch({ type: 'DEV_PLAN_INVOICE_DETAILS_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var getProRatedAmount = function (resellerOrgId, managedOrgId, devPlanId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var proRatedAmount, err_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'GET_PRORATED_AMOUNT_REQUEST' });
                    return [4 /*yield*/, DeveloperPlansService.getManagedOrgProRatedAmount(resellerOrgId, managedOrgId, devPlanId)];
                case 1:
                    proRatedAmount = (_a.sent()).object;
                    dispatch({
                        type: 'GET_PRORATED_AMOUNT_SUCCESS',
                        details: proRatedAmount,
                        managedOrgId: managedOrgId,
                        devPlanId: devPlanId,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_12 = _a.sent();
                    dispatch({
                        type: 'GET_PRORATED_AMOUNT_FAILURE',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var getProratedAmountForAddons = function (resellerOrgId, managedOrgId, bundles) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var amount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ResellerService.getProratedAmountForAddons(resellerOrgId, managedOrgId, bundles)];
                case 1:
                    amount = _a.sent();
                    dispatch({
                        type: 'GET_PRO_RATED_AMOUNT_FOR_ADDONS_SUCCESS',
                        proratedAmountForAddons: amount,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
};
